import { Box } from '@material-ui/core';
import React from 'react';

export default function Error() {
  return <Box>error ...</Box>;
}
